module.exports = __webpack_public_path__ + "img/image (10).b6e8ac0f.png";